
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import Antd from 'ant-design-vue'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import 'ant-design-vue/dist/antd.css'
// import Element from '@framework/element-ui'
// import './styles/element-variables.scss'

import './styles/common.scss' // global css

import App from './App'
import store from './store'
import router from './router'

// import '@framework/icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import $api from './api'
import $http from './utils/request'
import $utils from './utils/index'
import { getQueryObject } from '@framework/utils'

import { setToken, getToken, removeToken } from '@framework/utils/auth'
import VCharts from 'v-charts'
import PageMain from './layout/page-main'
import Login from '@/components/login/index'
import Register from '@/components/register/index'
import Resetpwd from '@/components/resetpwd/index'
import UserAgreement from '@/components/userAgreement'

import moment from 'moment'
require('script-loader!file-saver')

const token = getQueryObject().token
token && setToken(token)
// import * as filters from '@framework/filters' // global filters

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
Vue.prototype.$utils = $utils
Vue.prototype.$api = $api
Vue.prototype.$http = $http
Vue.prototype.$setToken = setToken
Vue.prototype.$getToken = getToken
Vue.prototype.$removeToken = removeToken
Vue.prototype.$moment = moment
Vue.prototype.$down = async(api, params, fileName) => {
  api.responseType = 'blob'
  api.origin = 'true'
  const res = await $http(api, params)
  // eslint-disable-next-line no-undef
  saveAs(new Blob([res.data], {
    type: 'application/octet-stream'
  }), (fileName || moment().format('YYYY-MM-DD HH-mm-ss') + '.xlsx'))
}
Vue.use(Antd)
Vue.use(VCharts)
Vue.component('PageMain', PageMain)
// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })

// register global utility filters
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })

Vue.config.productionTip = false
Login.store = store
Register.store = store
const login = new Vue(Login)
const register = new Vue(Register)
const resetpwd = new Vue(Resetpwd)
const userAgreement = new Vue(UserAgreement)
Vue.prototype.$login = login
Vue.prototype.$register = register
Vue.prototype.$resetpwd = resetpwd
Vue.prototype.$userAgreement = userAgreement

window.app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

document.body.appendChild(login.$mount().$el)
document.body.appendChild(register.$mount().$el)
document.body.appendChild(resetpwd.$mount().$el)
document.body.appendChild(userAgreement.$mount().$el)
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?49da60e7cb5fb564e8fe3979120bc74c'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
// login.$mount(document.body.appendChild(document.createElement('div')))
